import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import api from 'api';
import styled from 'styled-components';
import actions from 'actions';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const InvitedActions = ({
  events, invitations, onAccept, onReject, onGroupJoined, history,
}) => {
  const invitationId = events[0].invitation;
  const invitationExists = invitations.find(i => (i._id === invitationId) && !i.acceptedAt);

  const acceptInvite = useCallback(() => {
    api.invitations.accept(invitationId, ({ group }) => {
      onAccept(invitationId);
      toast.success('Group joined');
      onGroupJoined(group);
      history.push(`/groups/${group._id}`);
    }, (err) => {
      toast.error(err.message);
    });
  }, [invitationId, onAccept, onGroupJoined, history]);

  const rejectInvite = useCallback(() => {
    api.invitations.reject(invitationId, () => {
      onReject(invitationId);
      toast.success('Group invitation rejected');
    }, (err) => {
      toast.error(err.message);
    });
  }, [invitationId, onReject]);

  if (!invitationExists) return null;
  return (
    <ButtonContainer>
      <Button icon="check" color="green" size="small" onClick={acceptInvite} style={{ marginBottom: 5 }} />
      <Button basic icon="close" size="small" onClick={rejectInvite} />
    </ButtonContainer>
  );
};

const mapDispatchToProps = dispatch => ({
  onGroupJoined: group => dispatch(actions.user.joinGroup(group)),
});

export default connect(null, mapDispatchToProps)(withRouter(InvitedActions));
